@if (messages().length) {
  <div #summary class="alert alert-danger" role="alert" tabindex="-1">
    <strong>{{ heading }}</strong>
    @if (messages().length > collapsedLimit) {
      <p class="small mb-1">Showing {{ visibleErrors().length }} of {{ messages().length }} errors.</p>
    }
    <ul [id]="listId" class="mb-0">
      @for (error of visibleErrors(); track $index) {
        <li>{{ error }}</li>
      }
    </ul>
    @if (messages().length > collapsedLimit) {
      <button
        type="button"
        class="btn btn-link alert-link p-0 mt-2"
        [attr.aria-expanded]="expanded()"
        [attr.aria-controls]="listId"
        (click)="expanded.set(!expanded())"
      >
        @if (expanded()) {
          Show less
        } @else {
          Show more ({{ messages().length - collapsedLimit }} more)
        }
      </button>
    }
  </div>
}
